import { LoginOutlined } from "@ant-design/icons";
import { Button, ConfigProvider, Form, Input, Layout } from "antd";
import { useNavigate } from "react-router-dom";
import { darkTheme } from "../theme";

const GOLD = "#c8a55a";

function LoginPage() {
  const navigate = useNavigate();

  const onFinish = (values) => {
    navigate("/");
  };

  return (
    <ConfigProvider theme={darkTheme}>
      <Layout
        style={{
          minHeight: "100vh",
          background: "radial-gradient(ellipse at 30% 20%, #162240 0%, #0b1426 70%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div style={{ width: "100%", maxWidth: 400, padding: "0 24px" }}>
          {/* Brand */}
          <div style={{ textAlign: "center", marginBottom: 40 }}>
            <span
              style={{
                fontFamily: "'Syne', sans-serif",
                fontWeight: 800,
                fontSize: 36,
                color: GOLD,
                letterSpacing: "0.3px",
              }}
            >
              PA Alliance
            </span>
            <div
              style={{
                color: "rgba(255, 255, 255, 0.45)",
                fontSize: 13,
                marginTop: 8,
                letterSpacing: "0.5px",
                textTransform: "uppercase",
              }}
            >
              CRM Portal
            </div>
          </div>

          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Please enter your email" }]}
            >
              <Input autoFocus placeholder="Enter your email" />
            </Form.Item>
            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: "Please enter your password" }]}
            >
              <Input.Password placeholder="Enter your password" />
            </Form.Item>
            <Form.Item
              label="One Time Password"
              name="otp"
              rules={[{ required: true, message: "Please enter OTP" }]}
            >
              <Input placeholder="Enter OTP" />
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                icon={<LoginOutlined />}
                block
                htmlType="submit"
                style={{
                  height: 44,
                  fontSize: 15,
                  fontWeight: 600,
                }}
              >
                Sign In
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Layout>
    </ConfigProvider>
  );
}

export default LoginPage;
